export default (date) => {
    const yy = date.toString().substring(0, 4);
    const mm = date.toString().substring(4, 6);
    const dd = date.toString().substring(6, 8);
    return yy + "年" + mm + "月" + dd + "日";
};